import styled from "styled-components";
import PieChart from "../../components/charts/PieChart";
import Users from "../users/Users";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import ENDPOINT from "../../context/EndPoint";
import { Info } from "react-bootstrap-icons";
import { NavItem } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import StudentTicketItem from "../support/StudentTicketItem";
import CustomerSupportTicketItem from "../customer/CustomerTicketItem";
import GetStatistics from "../../actions/statistics/GetStatistics";
import SecurityHeaders from "../../context/SecurityHeaders";
import StudentsSupportPage from "../support/StudentsSupportPage";
import CustomerSupportPage from "../customer/CustomerSupportPage";
import Localbase from "localbase";
import PriceFormat from "../../context/PriceFormat";
import ModeWiseCourseRegistration from "../../components/charts/CourseRegistrationStatus";
import { useActionsContext } from "../../context/ActionsContext";

function SuperAdminDashboard({ permission }) {
  const [total, setTotal] = useState();
  const [doubts, setdoubts] = useState([]);
  const [info, setinfo] = useState();
  const [response, setResponse] = useState(doubts);
  const [statistics, setstatistics] = useState(null);
  const { user } = useContext(AuthContext);
  const userdata = user;
  const params = useParams();
  const db = new Localbase("db");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getresult = async () => {
    try {
      const data = new FormData();
      const res = await axios.post(
        ENDPOINT + "super-admin-statstics.php",
        data,
        { "content-type": "multipart/form-data" }
      );

      if (res.data) {
        setTotal(res.data);
        db.collection("paths").add({ total: res.data }, "total");
        // console.log(res.data.revenue)
      } else {
        console.error(res.data.revenue);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const GetDoubts = async () => {
    const data = new FormData();
    data.append("session", user.SessionId);
    const res = await axios.post(
      ENDPOINT + "admin-get-doubt-requests.php",
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    if (res) {
      console.log("hoilday", res.data.data);
      // console.log("Resp  is " + JSON.stringify(res.data.data))
      if (res.data.status === "success") {
        setdoubts(res.data.data);

        db.collection("paths").add({ doubts: res.data.data }, "doubts");
        //  // console.log(res.data.data)
      }
    }
  };
  const FetchCustomerRequests = async () => {
    const data = new FormData();
    data.append("session", user.SessionId);

    const res = await axios.post(ENDPOINT + "", data, SecurityHeaders);

    if (res) {
      if (res.data.status === "success") {
        setdoubts(res.data.data);

        db.collection("paths").add(
          { customer_doubts: res.data.data },
          "customer_doubts"
        );
      }
    }
  };
  const load = () => {
    FetchCustomerRequests();
  };

  const Reload = () => {
    GetDoubts();
  };

  const GetStats = async () => {
    const res = await GetStatistics({ payload: { SessionId: user.SessionId } });

    if (res) {
      if (res.status === "success") {
        setinfo(res.data);
        db.collection("paths").add({ info: res.data }, "info");
      }
      // console.log("stat is" + JSON.stringify(res));
    }
  };
  const [courses, setCourses] = useState();
  const GetCourses = async () => {
    const data = new FormData();
    data.append("limit", 10);
    const res = await axios.post(
      ENDPOINT + "get-course-enrollment.php",
      data,
      SecurityHeaders
    );
    if (res.data) {
      setCourses(res.data.data);
      db.collection("paths").add({ courses: res.data.data }, "courses");
      // console.log(res.data.data)
    }
  };
  useEffect(() => {
    GetCourses();
  }, []);

  useEffect(() => {
    setResponse(doubts);
  }, [doubts]);

  useEffect(() => {
    GetDoubts({ payload: { id: null } });

    // console.log("doubts " + doubts);
  }, []);

  useEffect(() => {
    getresult();
  }, []);

  const Getofflinedata = () => {
    db.collection("paths")
      .doc("total")
      .get()
      .then((data) => {
        if (data) {
          setTotal(data.total);
        }
      });
    db.collection("paths")
      .doc("info")
      .get()
      .then((data) => {
        if (data) {
          setinfo(data.info);
        }
      });
    db.collection("paths")
      .doc("doubts")
      .get()
      .then((data) => {
        if (data) {
          setdoubts(data.doubts);
        }
      });
    db.collection("paths")
      .doc("courses")
      .get()
      .then((data) => {
        if (data) {
          setCourses(data.courses);
        }
      });
  };

  useEffect(() => {
    GetStats();
  }, []);

  useEffect(() => {
    Getofflinedata();
  }, []);

  return (
    <>
      {total ? (
        <>
          <div className="container-fluid  dashboard-page">
            <div className="row">
              <div className="col">
                <div className="h-100">
                  {parseInt(permission.super_admin) === 1 ? (
                    <>
                      {/*end row*/}
                      <div className="row dashboard-data">
                        <div className="col-xl-3 col-md-6 p-2 col-6">
                          {/* card */}
                          <div className="card card-animate">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                    Total Earnings
                                  </p>
                                </div>
                                <div className="flex-shrink-0 d-none d-md-block">
                                  <h5 className="text-success fs-14 mb-0">
                                    <i className="ri-arrow-right-up-line fs-13 align-middle" />
                                    +16.24 %
                                  </h5>
                                </div>
                              </div>
                              <div className="d-flex align-items-end justify-content-between mt-1 mt-md-4">
                                <div>
                                  <h4 className="fs-20 fs-md-22 fw-semibold ff-secondary mb-3 mb-md-4">
                                    <span
                                      className="counter-value"
                                      data-target="559.25"
                                    >
                                      {"+" + total.revenue
                                        ? PriceFormat(total.revenue)
                                        : 2000}
                                    </span>
                                  </h4>
                                  <a
                                    href="#"
                                    className="text-decoration-underline"
                                  >
                                    View{" "}
                                    <span className="d-none d-md-block">
                                      Payments
                                    </span>
                                  </a>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-success-subtle rounded fs-3">
                                    <i className="bx bx-dollar-circle text-success" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}
                        <div className="col-xl-3 col-md-6 p-2 col-6">
                          {/* card */}
                          <div className="card card-animate">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                    Total Students
                                  </p>
                                </div>
                                <div className="flex-shrink-0 d-none d-md-block">
                                  <h5 className="text-danger fs-14 mb-0">
                                    <i className="ri-arrow-right-down-line fs-13 align-middle" />
                                    -3.57 %
                                  </h5>
                                </div>
                              </div>
                              <div className="d-flex align-items-end justify-content-between mt-1 mt-md-4">
                                <div>
                                  <h4 className="fs-22 fw-semibold ff-secondary mb-3 mb-md-4">
                                    <span
                                      className="counter-value"
                                      data-target={36894}
                                    >
                                      {"+" + total.students
                                        ? total.students
                                        : 2000}
                                    </span>
                                  </h4>
                                  <a
                                    href="#"
                                    className="text-decoration-underline"
                                  >
                                    View{" "}
                                    <span className="d-none d-md-block">
                                      Orders
                                    </span>
                                  </a>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-info-subtle rounded fs-3">
                                    <i className="bx bx-shopping-bag text-info" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>

                        {/* end col */}
                        <div className="col-xl-3 col-md-6 p-2 col-6">
                          {/* card */}
                          <div className="card card-animate">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                    Total Team
                                  </p>
                                </div>
                                <div className="flex-shrink-0 d-none d-md-block">
                                  <h5 className="text-success fs-14 mb-0">
                                    <i className="ri-arrow-right-up-line fs-13 align-middle" />
                                    +29.08 %
                                  </h5>
                                </div>
                              </div>
                              <div className="d-flex align-items-end justify-content-between mt-1 mt-md-4">
                                <div>
                                  <h4 className="fs-22 fw-semibold ff-secondary mb-3 mb-md-4">
                                    <span
                                      className="counter-value"
                                      data-target="183.35"
                                    >
                                      {"+" + total.teams ? total.teams : 2000}
                                    </span>
                                  </h4>
                                  <a
                                    href="#"
                                    className="text-decoration-underline"
                                  >
                                    View{" "}
                                    <span className="d-none d-md-block">
                                      Team
                                    </span>
                                  </a>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-warning-subtle rounded fs-3">
                                    <i className="bx bx-user-circle text-warning" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}

                        {/* end col */}
                        <div className="col-xl-3 col-md-6 p-2 col-6">
                          {/* card */}
                          <div className="card card-animate">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                                    Balance
                                  </p>
                                </div>
                                <div className="flex-shrink-0 d-none d-md-block">
                                  <h5 className="text-success fs-14 mb-0">
                                    <i className="ri-arrow-right-up-line fs-13 align-middle" />
                                    +29.08 %
                                  </h5>
                                </div>
                              </div>
                              <div className="d-flex align-items-end justify-content-between mt-1 mt-md-4">
                                <div>
                                  <h4 className="fs-22 fw-semibold ff-secondary mb-3 mb-md-4">
                                    <span
                                      className="counter-value"
                                      data-target="183.35"
                                    >
                                      {"+" + total.total_balance
                                        ? PriceFormat(total.total_balance)
                                        : 2000}
                                    </span>
                                  </h4>
                                  <a
                                    href="#"
                                    className="text-decoration-underline"
                                  >
                                    View{" "}
                                    <span className="d-none d-md-block">
                                      Payments
                                    </span>
                                  </a>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-warning-subtle rounded fs-3">
                                    <i className="bx bx-user-circle text-warning" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}
                      </div>
                      {/* end row*/}
                    </>
                  ) : (
                    <></>
                  )}

                  <div className="row">
                    {/* end col sliding section*/}
                    <div className="col-xxl-8 col-lg-8 order-xxl-0 order-first d-none d-md-flex flex-wrap">
                      <div className="no-wrap d-none overflow-x-scroll">
                        {/* end col */}
                        <div className="col-lg-4 me-2 col-md-4">
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                                    <i className="ri-arrow-up-circle-fill align-middle" />
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                    Pending Registrations
                                  </p>
                                  <h4 className=" mb-0">
                                    <span
                                      className="counter-value"
                                      data-target="19523.25"
                                    >
                                      {"+" + total.pending_registrations
                                        ? total.pending_registrations
                                        : 2000}
                                    </span>
                                  </h4>
                                </div>
                                <div className="flex-shrink-0 align-self-end">
                                  <span className="badge bg-success-subtle text-success">
                                    {"+" + total.registrations
                                      ? total.registrations
                                      : 2000}{" "}
                                    Total<span> </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}
                        <div className="col-lg-5 me-2 col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                    <i className="ri-money-dollar-circle-fill align-middle" />
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                    Active Workshop Leads
                                  </p>
                                  <h4 className=" mb-0">
                                    <span
                                      className="counter-value"
                                      data-target="2390.68"
                                    >
                                      {"+" + total.pending_leads
                                        ? total.pending_leads
                                        : 2000}
                                    </span>
                                  </h4>
                                </div>
                                <div className="flex-shrink-0 align-self-end">
                                  <span className="badge bg-success-subtle text-success">
                                    {total.today_total_leads
                                      ? total.today_total_leads
                                      : 2000}{" "}
                                    Total<span> </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>

                        <div className="col-lg-5 me-2 col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                    <i className="ri-arrow-down-circle-fill align-middle" />
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                    Active Ambassadors{" "}
                                  </p>
                                  <h4 className=" mb-0">
                                    <span
                                      className="counter-value"
                                      data-target="14799.44"
                                    >
                                      {"+" + total.pending_ambassadors
                                        ? total.pending_ambassadors
                                        : 2000}
                                    </span>
                                  </h4>
                                </div>
                                <div className="flex-shrink-0 align-self-end">
                                  <span className="badge bg-danger-subtle text-danger">
                                    <span>
                                      {"+" + total.ambassadors
                                        ? total.ambassadors
                                        : 2000}{" "}
                                      Total
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}

                        {/* end col */}
                        <div className="col-lg-4 me-2 col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                    <i className="ri-arrow-down-circle-fill align-middle" />
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                    Active Jobs{" "}
                                  </p>
                                  <h4 className=" mb-0">
                                    <span
                                      className="counter-value"
                                      data-target="14799.44"
                                    >
                                      {"+" + total.pending_internships
                                        ? total.pending_internships
                                        : 2000}
                                    </span>
                                  </h4>
                                </div>
                                <div className="flex-shrink-0 align-self-end">
                                  <span className="badge bg-danger-subtle text-danger">
                                    <span>
                                      {" "}
                                      {"+" + total.internships
                                        ? total.internships
                                        : 2000}{" "}
                                      Total
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}

                        {/* end col */}
                        <div className="col-lg-4 col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                    <i className="ri-arrow-down-circle-fill align-middle" />
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                    Active Jobs{" "}
                                  </p>
                                  <h4 className=" mb-0">
                                    <span
                                      className="counter-value"
                                      data-target="14799.44"
                                    >
                                      {"+" + total.pending_jobs
                                        ? total.pending_jobs
                                        : 2000}
                                    </span>
                                  </h4>
                                </div>
                                <div className="flex-shrink-0 align-self-end">
                                  <span className="badge bg-danger-subtle text-danger">
                                    <span>
                                      {"+" + total.jobs ? total.jobs : 2000}{" "}
                                      Total{" "}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}

                        {/* end col */}
                        <div className="col-lg-4 col-md-6">
                          <div className="card">
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                  <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                                    <i className="ri-arrow-down-circle-fill align-middle" />
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                                    Active Batches{" "}
                                  </p>
                                  <h4 className=" mb-0">
                                    <span
                                      className="counter-value"
                                      data-target="14799.44"
                                    >
                                      {"+" + total.pending_cai_batches
                                        ? total.pending_cai_batches
                                        : 2000}
                                    </span>
                                  </h4>
                                </div>
                                <div className="flex-shrink-0 align-self-end">
                                  <span className="badge bg-danger-subtle text-danger">
                                    <span>
                                      {"+" + total.cai_batches
                                        ? total.cai_batches
                                        : 2000}{" "}
                                      Total
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                          {/* end card */}
                        </div>
                        {/* end col */}
                      </div>

                      <div className="d-flex w-100">
                        <div className="col-lg-12 ">
                          <div
                            className="card overflow-scroll"
                            style={{ height: 400 }}
                          >
                            <div className="card-header border-0 align-items-center d-flex">
                              <h4 className="card-title mb-0 flex-grow-1">
                                Recent Course Registrations
                              </h4>
                              <div>
                                <div className="d-flex">
                                  <button
                                    type="button"
                                    className="btn btn-soft-secondary btn-sm material-shadow-none me-1"
                                  >
                                    7D
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-soft-secondary btn-sm material-shadow-none me-1"
                                  >
                                    1M
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-soft-secondary btn-sm material-shadow-none me-1"
                                  >
                                    1Y
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-soft-primary btn-sm material-shadow-none"
                                  >
                                    ALL
                                  </button>
                                </div>
                              </div>
                            </div>

                            {/* end card header */}
                            <div className="card-body">
                              <div className="table-responsive table-card">
                                <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                                  <thead className="text-muted table-light">
                                    <tr>
                                      <th scope="col">Student</th>

                                      <th scope="col">Course Url</th>
                                      <th scope="col">Purchase Price</th>

                                      <th scope="col">Purchase Status</th>
                                    </tr>
                                  </thead>
                                  {courses && courses.length > 0 ? (
                                    <>
                                      {courses.map((item) => (
                                        <tbody>
                                          <tr>
                                            <td>
                                              <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-2">
                                                  <img
                                                    src={item.profile_pic}
                                                    alt=""
                                                    className="avatar-xs rounded-circle material-shadow"
                                                  />
                                                </div>
                                                <div className="flex-grow-1"></div>
                                                <h5>{item.first_name}</h5>
                                              </div>
                                            </td>

                                            <td>{item.course_url}</td>
                                            <td>
                                              <span className="text-success">
                                                ₹{item.purchase_price}
                                              </span>
                                            </td>

                                            <td>
                                              <span className="badge bg-success-subtle text-success">
                                                {item.purchase_status}
                                              </span>
                                            </td>
                                          </tr>
                                          {/* end tr */}
                                          {/* end tr */}
                                        </tbody>
                                      ))}
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {/* end tbody */}
                                </table>
                                {/* end table */}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/*Graphical data */}

                        <div className="col-lg-5 ps-2"></div>
                      </div>
                    </div>
                    {/* end col */}

                    <div className="col-lg-4 ">
                      <div className="card">
                        <div className="card-header align-items-center d-flex">
                          <h4 className="card-title mb-0 flex-grow-1">
                            Upcoming Activities (Today)
                          </h4>
                          <div className="flex-shrink-0">
                            <div className="dropdown card-header-dropdown">
                              <a
                                className="text-reset dropdown-btn"
                                href="#"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <span className="text-muted fs-18">
                                  <i className="mdi mdi-dots-vertical" />
                                </span>
                              </a>
                              <div className="dropdown-menu dropdown-menu-end">
                                <a className="dropdown-item" href="#">
                                  Edit
                                </a>
                                <a className="dropdown-item" href="#">
                                  Remove
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* end card header */}
                        <div className="card-body pt-0">
                          <ul className="list-group list-group-flush border-dashed">
                            <li className="list-group-item ps-0">
                              <div className="row align-items-center g-3">
                                <div className="col-auto">
                                  <div className="avatar-sm p-1 py-2 h-auto bg-light rounded-3 material-shadow">
                                    <div className="text-center">
                                      <h5 className="mb-0">
                                        {"+" + total.total_classes
                                          ? total.total_classes
                                          : 2000}
                                      </h5>
                                      <div className="text-muted"></div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col">
                                  <a href="#" className="text-reset fs-14 mb-0">
                                    Total Classes
                                  </a>
                                  <h5 className="text-muted mt-0 mb-1 fs-13">
                                    {"+" + total.total_pending_classes
                                      ? total.total_pending_classes
                                      : 2000}{" "}
                                    pending
                                  </h5>
                                </div>
                              </div>
                              {/* end row */}
                            </li>
                            {/* end */}
                            <li className="list-group-item ps-0">
                              <div className="row align-items-center g-3">
                                <div className="col-auto">
                                  <div className="avatar-sm p-1 py-2 h-auto bg-light rounded-3 material-shadow">
                                    <div className="text-center">
                                      <h5 className="mb-0">
                                        {"+" + total.today_total_meetings
                                          ? total.today_total_meetings
                                          : 2000}
                                      </h5>
                                      <div className="text-muted"></div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col">
                                  <a href="#" className="text-reset fs-14 mb-0">
                                    Total Meetings
                                  </a>
                                  <h5 className="text-muted mt-0 mb-1 fs-13">
                                    {"+" + total.pending_meetings
                                      ? total.pending_meetings
                                      : 2000}{" "}
                                    pending
                                  </h5>
                                </div>
                              </div>
                              {/* end row */}
                            </li>
                            {/* end */}
                            <li className="list-group-item ps-0">
                              <div className="row align-items-center g-3">
                                <div className="col-auto">
                                  <div className="avatar-sm p-1 py-2 h-auto bg-light rounded-3 material-shadow">
                                    <div className="text-center">
                                      <h5 className="mb-0">
                                        {"+" + total.today_total_doubt
                                          ? total.today_total_doubt
                                          : 2000}
                                      </h5>
                                      <div className="text-muted"></div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col">
                                  <a href="#" className="text-reset fs-14 mb-0">
                                    {"+" + total.total_doubts
                                      ? total.total_doubts
                                      : 2000}{" "}
                                    Student Doubts
                                  </a>
                                  <h5 className="text-muted mt-0 mb-1 fs-13">
                                    {"+" + total.pending_doubts
                                      ? total.pending_doubts
                                      : 2000}{" "}
                                    Pending
                                  </h5>
                                </div>
                              </div>
                              {/* end row */}
                            </li>
                            {/* end */}
                            <li className="list-group-item ps-0">
                              <div className="row align-items-center g-3">
                                <div className="col-auto">
                                  <div className="avatar-sm p-1 py-2 h-auto bg-light rounded-3 material-shadow">
                                    <div className="text-center">
                                      <h5 className="mb-0">
                                        {"+" + total.today_logs
                                          ? total.today_logs
                                          : 2000}
                                      </h5>
                                      <div className="text-muted"></div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col">
                                  <a href="#" className="text-reset fs-14 mb-0">
                                    Customer Tickets
                                  </a>
                                  <h5 className="text-muted mt-0 mb-1 fs-13">
                                    {"+" + total.pending_logs
                                      ? total.pending_logs
                                      : 2000}{" "}
                                    pending
                                  </h5>
                                </div>
                              </div>
                              {/* end row */}
                            </li>
                            {/* end */}

                            {/* end */}
                            <li className="list-group-item ps-0">
                              <div className="row align-items-center g-3">
                                <div className="col-auto">
                                  <div className="avatar-sm p-1 py-2 h-auto bg-light rounded-3 material-shadow">
                                    <div className="text-center">
                                      <h5 className="mb-0">
                                        {"+" + total.today_total_leads
                                          ? total.today_total_leads
                                          : 2000}
                                      </h5>
                                      <div className="text-muted"></div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col">
                                  <a href="#" className="text-reset fs-14 mb-0">
                                    New Leads
                                  </a>
                                  <h5 className="text-muted mt-0 mb-1 fs-13">
                                    {"+" + total.pending_leads
                                      ? total.pending_leads
                                      : 2000}{" "}
                                    Pending Interaction
                                  </h5>
                                </div>
                              </div>
                              {/* end row */}
                            </li>
                            {/* end */}
                          </ul>
                          {/* end */}
                        </div>
                        {/* end card body */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      <ModeWiseCourseRegistration />
    </>
  );
}

export default SuperAdminDashboard;

const StyledSuperAdminDashboard = styled.div`
  h1 {
    color: red;
  }
`;
